import React, { useEffect } from "react";
import {
  Button,
  Divider,
  Form,
  Input,
  Typography,
  Row,
  Card,
  message,
  Alert,
} from "antd";
import { PhoneOutlined, SendOutlined } from "@ant-design/icons";
import { data } from "react-router-dom";
import axios from "axios";

const { Title } = Typography;

const CallBackPage = () => {
  const [form] = Form.useForm();
  const [formSuccessMessage, setFormSuccessMessage] = React.useState("");

  useEffect(() => {
    logUserActivity({ detail: "" });
    document.title = "JOJ | Call Back Request ";
  }, []);

  const logUserActivity = async ({ detail }) => {
    const tokenString = localStorage.getItem("token");

    try {
      const jsondata = JSON.stringify({
        ScreenID: "6",
        DetailID: "0",
        Detail: detail,
      });

      let config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/UserActivity/InsertActivity",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
        data: jsondata,
      };

      axios
        .request(config)
        .then((response) => {})
        .catch((error) => {});
    } catch (err) {}
  };

  const handleSubmit = (values) => {
    message.success("Request submitted successfully!");

    try {
      setFormSuccessMessage("");
      const listData = {
        Name: values.name,
        ContactNumber: values.mobile,
      };

      let config = {
        method: "post",

        url: global.config.APIURL.BaseURL + "api/CallBackRequest/InsertRequest",
        headers: {
          "Content-Type": "application/json",
        },
        data: listData,
      };

      axios
        .request(config)
        .then((response) => {
          logUserActivity({ detail: "Call-Back-Requested" });
          setFormSuccessMessage("Request submitted successfully!");
          form.resetFields();
        })
        .catch((error) => {});
    } catch (err) {}
  };

  return (
    <div style={{ maxWidth: 550, margin: "40px auto", padding: "0 16px" }}>
      <Card>
        <Title level={2} style={{ textAlign: "center", marginBottom: 16 }}>
          Contact Our Sales Team
        </Title>

        <Divider plain style={{ fontWeight: "bold" }}>
          Request Call Back
        </Divider>

        <Card
          bordered
          style={{ borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
        >
          <Row justify="center" style={{ marginBottom: 24 }}>
            <Button
              type="primary"
              icon={<PhoneOutlined />}
              size="large"
              href="tel:8000002808"
              onClick={() => logUserActivity({ detail: "Call Us" })}
              style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
            >
              Call Us: 8000002808
            </Button>
          </Row>

          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              label="Your Name"
              name="name"
              rules={[{ required: true, message: "Please enter your name" }]}
            >
              <Input placeholder="Enter your name" />
            </Form.Item>

            <Form.Item
              label="Mobile Number"
              name="mobile"
              rules={[
                { required: true, message: "Please enter your mobile number" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Enter a valid 10-digit number",
                },
              ]}
            >
              <Input
                placeholder="Enter 10-digit mobile number"
                maxLength={10}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                icon={<SendOutlined />}
                size="large"
                htmlType="submit"
                block
              >
                Submit Request
              </Button>

              {formSuccessMessage ? (
                <div
                  style={{ textAlign: "left", marginBottom: 16, marginTop: 16 }}
                >
                  <Alert message={formSuccessMessage} type="success" />
                </div>
              ) : null}
            </Form.Item>
          </Form>
        </Card>
      </Card>
    </div>
  );
};

export default CallBackPage;
